import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
// import { Link } from 'react-router-dom';

import { getCorporatecontactList, GetResCorporatedetail } from '../../Services/Service';
import ReservationSidebar from '../Commun/ReservationSidebar';
import ReservationHeader from '../Commun/ReservationHeader';
import { useProperty } from '../../PropertyContext';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import '../Booking Details/BookingList.css';
import '../Agent Details/AgentList.css';
import { deleteReservationCorporate } from '../../Redux/Slices/Reservation/deleteslice';



const ReservationCompanyList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();
    const deleting = useSelector((state) => state.reservationDelete.deleting);
    const propertyID = selectedProperty?.PropertyID;
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [CorporateList, steCorporateList] = useState();
    const [contactList, setContactList] = useState([]);
    const [selectedLoginID, setSelectedLoginID] = useState(null);



    useEffect(() => {
        if (location.state?.showSuccess) {
            setShowSuccess(true);
            setSuccessMessage(location.state.successMessage);

            setTimeout(() => {
                setShowSuccess(false);
            }, 4000);
        }
    }, [location.state]);


    const getCorporateDetails = useCallback(async () => {
            setLoading(true);
            try {
                const result = await GetResCorporatedetail(propertyID);
                // console.log("corporate data", result)
                if (Array.isArray(result)) {
                    steCorporateList(result);
                }
            }
            catch (error) {
                console.log("error getting corporate detail", error);
            } finally {
                setLoading(false);
            }
    }, [propertyID]);

    useEffect(() => {
        getCorporateDetails();
    }, [getCorporateDetails]);


    // useEffect(() => {
    //     if (CorporateList?.length > 0 && window.$) {
    //         if ($.fn.DataTable.isDataTable('.basic-datatables')) {
    //             $('.basic-datatables').DataTable().destroy();
    //         }
    //         $('.basic-datatables').DataTable();
    //     }
    // }, [CorporateList]);



    // Contact List API Call
    const handleOpenContactList = async (loginID) => {
        setSelectedLoginID(loginID);

        try {
            const contactResult = await getCorporatecontactList(loginID);
            setContactList(contactResult?.Table || []);
        } catch (error) {
            console.error("Error fetching contact list:", error);
            setContactList([]);
        }
    };


    const handleEditClick = (corporateItem) => {
        navigate(`/Reservation/Updatecompany/${corporateItem.CorporateID}`, { state: { corporateItem } });
    };


    const handleNewContactClick = () => {
        const modalElement = document.getElementById('example-modal-lg');
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) modalInstance.hide();

        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();

        if (selectedLoginID) {
            console.log("localStorage:", localStorage);

            const propertyID = localStorage.getItem("PropertyID");
            navigate(`/Property/RateUpdateForm?R=CP-${selectedLoginID}&PropertyID=${propertyID}`);
        } else {
            alert("No Corporate Selected");
        }
    };

    const handleDeleteClick = async (corporateID) => {
        const shouldDelete = await swal({ title: "Are you sure?", text: "Once deleted, this company cannot be recovered.", icon: "warning", buttons: ["Cancel", "Delete"], dangerMode: true });
        if (!shouldDelete) return;
        try {
            const { response } = await dispatch(deleteReservationCorporate({ CorporateID: corporateID, PropID: propertyID })).unwrap();
            await getCorporateDetails();
            await swal(response?.Message || response?.message || "Company deleted successfully.", { icon: "success" });
        } catch (error) {
            await swal(error?.Message || error?.message || "Unable to delete company.", { icon: "error" });
        }
    };

    const formattedData = CorporateList?.map(item => ({
        ...item,
        FullName: `${item.FirstName || ""} ${item.MidlleName || ""} ${item.LastName || ""}`.trim(),
        Phone: item.MobileNo || item.TelNo || ""
    }));

    return (
        <>

            {(loading || deleting) && (
                <FullScreenLoader />
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    {showSuccess && (
                                        <div className="alert alert-success d-flex align-items-center" role="alert">
                                            <i className="feather-check-circle flex-shrink-0 me-2"></i>
                                            <div>{successMessage}</div>
                                        </div>
                                    )}
                                    <div className="card booking-list-card agent-list-card">
                                        <div className="card-header booking-list-header">
                                            <h4 className="card-title mb-0">Company List</h4>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive booking-list-table-wrap agent-list-table-wrap">
                                                {/* <table
                                                    // id="basic-datatables"
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>opera link id</th>
                                                            <th>Mealplan Send</th>
                                                            <th>TA</th>
                                                            <th>City</th>
                                                            <th>Contact Person Name</th>
                                                            <th>Phone</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {CorporateList?.map((item, index) => (
                                                            <tr key={item.CorporateID || index}>
                                                                <td>{item.OperaProfileID ? "Yes" : "No"}</td>
                                                                <td>{String(item.IsPushMealPlan) === "1" ? "Yes" : "No"}</td>
                                                                <td>{item.TA_Name || 'N/A'}</td>
                                                                <td>{item.City || 'N/A'}</td>
                                                                <td>{`${item.FirstName} ${item.MidlleName} ${item.LastName}`.trim() || 'N/A'}</td>

                                                                <td>{item.MobileNo || item.TelNo || 'N/A'}</td>

                                                                <td className="text-center">
                                                                    <div className="dropdown dropdown-action"
                                                                    //  style={{ position: "absolute", top: "133px", right: "61px" }}
                                                                     >
                                                                        <a href="/" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <button className="dropdown-item" onClick={() => handleEditClick(item)}>
                                                                                <i className="fas fa-edit me-2"></i>
                                                                                Edit
                                                                            </button>

                                                                            <button type="button" className=" dropdown-item" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={() => handleOpenContactList(item.LoginID)}><i className="fas fa-user me-2"></i> Contact List</button>
                                                                            <button className="dropdown-item" type="button">
                                                                                <i className="fas fa-trash me-2"></i>
                                                                                Delete
                                                                            </button>
                                                                            <button type="button" className=" dropdown-item waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#con-close-modal"><i className="fas fa-cogs me-2"></i>Change Password</button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                </table> */}


                                                <DataTable
                                                    value={formattedData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                    stripedRows
                                                    showGridlines
                                                    responsiveLayout="scroll"
                                                    emptyMessage={
                                                        <div style={{ textAlign: "center", width: "100%" }}>
                                                            No company found.
                                                        </div>
                                                    }
                                                    className="p-datatable-bordered agent-list-table"
                                                    filterDisplay="row"
                                                >
                                                    <Column
                                                        header="opera link id"
                                                        body={(rowData) => (rowData.OperaProfileID ? "Yes" : "No")}
                                                    />

                                                    <Column
                                                        header="Mealplan Send"
                                                        body={(rowData) => (String(rowData.IsPushMealPlan) === "1" ? "Yes" : "No")}
                                                    />

                                                    <Column
                                                        field="TA_Name"
                                                        header="TA"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search TA"
                                                        body={(rowData) => rowData.TA_Name || "N/A"}
                                                    />

                                                    <Column
                                                        field="City"
                                                        header="City"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search City"
                                                        body={(rowData) => rowData.City || "N/A"}
                                                    />

                                                    <Column
                                                        field="FullName"
                                                        header="Contact Person Name"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Name"
                                                        body={(rowData) => rowData.FullName || "N/A"}
                                                    />

                                                    <Column
                                                        field="Phone"
                                                        header="Phone"
                                                        sortable
                                                        filter
                                                        showFilterMenu={false}
                                                        filterPlaceholder="Search Phone"
                                                        body={(rowData) => rowData.Phone || "N/A"}
                                                    />

                                                    <Column
                                                        header="Action"
                                                        body={(rowData) => (
                                                            <div className="text-center">
                                                                <div className="dropdown dropdown-action">
                                                                    <a
                                                                        href="/"
                                                                        className="action-icon"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                    </a>

                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleEditClick(rowData)}
                                                                        >
                                                                            <i className="fas fa-edit me-2"></i>
                                                                            Edit
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#example-modal-lg"
                                                                            onClick={() => handleOpenContactList(rowData.LoginID)}
                                                                        >
                                                                            <i className="fas fa-user me-2"></i>
                                                                            Contact List
                                                                        </button>

                                                                        <button className="dropdown-item" type="button" onClick={() => handleDeleteClick(rowData.CorporateID)} disabled={deleting}>
                                                                            <i className="fas fa-trash me-2"></i>
                                                                            Delete
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#con-close-modal"
                                                                        >
                                                                            <i className="fas fa-cogs me-2"></i>
                                                                            Change Password
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <>
                        {/*  Modal */}
                        <div
                            className="modal fade"
                            id="example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            contact list
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="table-responsive">

                                            <div className='text-end mb-3'>
                                                <button className="btn btn-sm btn-black" onClick={handleNewContactClick}>New Contact</button>
                                            </div>
                                            <table className="table table-bordered table-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Contact On</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {contactList.length > 0 ? (
                                                        contactList.map((contact, index) => (
                                                            <tr key={index}>
                                                                <td>{contact.StartDate || "N/A"}</td>
                                                                <td>{contact.EndDate || "N/A"}</td>
                                                                <td>{contact.CreatedDate || "N/A"}</td>
                                                                <td className='text-center'>
                                                                    <button className="btn btn-sm btn-dark py-1 px-2"><i className='fas fa-edit'></i></button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">No Contact Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Modal */}
                    </>

                    <>
                        <div
                            id="con-close-modal"
                            className="modal fade"
                            tabIndex={-1}
                            role="dialog"
                            aria-hidden="true"
                            style={{ display: "none" }}
                        >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Change Password</h4>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body p-4">
                                        <form>
                                            <div className='col-md-12 mb-3'>
                                                <label className='form-label fw-bold'>Password</label>
                                                <input type='text' className='form-control' />
                                            </div>

                                            <div className='col-md-12'>
                                                <label className='form-label fw-bold'>Confirm Password</label>
                                                <input type='text' className='form-control' />
                                            </div>
                                        </form>
                                    </div>
                                    <div className="modal-footer">

                                        <button
                                            type="button"
                                            className="btn btn-info waves-effect waves-light"
                                        >
                                            Password Change
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /.modal */}
                    </>



                </div>

            </div>

        </>
    );
};

export default ReservationCompanyList;
